import Header from '../header/Header';
import { FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styles from '../layout.module.sass';
import Navbar from '../navbar/Navbar';
// import { MENU_ITEMS } from '../menu-items';
import {
  BASE_MENU_ITEMS,
  SUPERUSER_MENU_ITEMS,
  NAV_ITEMS,
} from '../menu-items';
import { useAppSelector } from '../../../hooks/redux';
import { Roles } from '../../../consts/consts';
import { useTranslation } from 'react-i18next';
import { translateItems } from '../../../utils/translateItems';

const UserLayout: FC = () => {
  const { t } = useTranslation();
  const role = useAppSelector((state) => state.UserData.user?.role.name);
  const location = useLocation();
  const path = `/${location.pathname.split('/')[1]}`;

  //удалить этот блок, вернуть импорт
  const MENU_ITEMS = translateItems(
    [
      ...BASE_MENU_ITEMS,
      ...(role === Roles.SuperUser ? SUPERUSER_MENU_ITEMS : []),
    ],
    t,
  );

  const translatedNavItems = translateItems(NAV_ITEMS, t);

  const currentPage =
    translatedNavItems.find((item) => item.link === path) ||
    MENU_ITEMS.find((item) => item.link === path) ||
    MENU_ITEMS[0];

  return (
    <div className={styles.wrapper}>
      <div className={styles.navbar}>
        <Navbar menuItems={MENU_ITEMS} currentPage={currentPage} />
      </div>
      <div className={styles.header}>
        <Header menuItems={translatedNavItems} currentPage={currentPage} />
      </div>
      <div className={styles.main}>
        <Outlet />
      </div>
    </div>
  );
};

export default UserLayout;
